import { lastDateFromToday, today } from '@/store/helpers'

// eslint-disable-next-line import/prefer-default-export
export const modalDownloadTopupMutationDatepickerConfig = {
  locale: {
    format: 'dd/mm/yyyy',
    separator: ' - ',
    applyLabel: 'Terapkan',
    cancelLabel: 'Batal',
    fromLabel: 'Dari',
    toLabel: 'Sampai',
    customRangeLabel: 'Pilih Rentang',
  },
  ranges: {
    'Hari Ini': [today, today],
    '7 Hari Terakhir': [lastDateFromToday(7), today],
    '14 Hari Terakhir': [lastDateFromToday(14), today],
    'Bulan Ini': [lastDateFromToday(30), today],
    'Rentang Kustom': [null, null],
  },
}
